import {
  SET_USER_PERMISSION,
  LOGIN_STARTED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  USER_INFO_STARTED,
  USER_INFO_SUCCESS,
  USER_INFO_FAILED,
  LOGOUT_SUCCESS,
  USER_TOKEN_REFRESH,
  SET_USER_REALM,
  SET_ACCOUNT_SETTINGS,
} from '../actions/types';
import initialState from '../initialState';
import { set, first } from 'global/lib/lodash';

export default function authReducer(state = initialState.auth, action) {
  switch (action.type) {
    case USER_INFO_STARTED:
      return Object.assign({}, state, {
        userLoading: true,
      });
    case USER_INFO_SUCCESS:
      const user = { ...action.payload };

      if (user.realms) {
        set(user, 'highestRealm', first(user.realms));
      }

      return Object.assign({}, state, {
        user,
        userLoading: false,
      });
    case LOGIN_STARTED:
      return Object.assign({}, state, {
        loginFailed: null,
        loginStarted: true,
      });
    case USER_TOKEN_REFRESH:
    case LOGIN_SUCCESS:
      return Object.assign({}, state, {
        accessToken: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        accessTokenValidUntil: action.payload.expires_in,
        accessTokenSetAt: Math.floor(Date.now() / 1000),
        loginFailed: false,
        loginStarted: false,
      });
    case LOGOUT_SUCCESS:
      return Object.assign({}, state, initialState.auth);
    case LOGIN_FAILED:
      let newAuth = initialState.auth;
      newAuth.loginError = action.payload.error;
      newAuth.loginFailed = true;
      return Object.assign({}, state, newAuth);
    case USER_INFO_FAILED:
      return Object.assign({}, state, {
        userLoading: false,
      });
    case SET_USER_REALM:
      return {
        ...state,
        realm: action.realm,
      };
    case SET_USER_PERMISSION:
      return {
        ...state,
        permissions: action.permissions,
      };
    case SET_ACCOUNT_SETTINGS:
      return {
        ...state,
        accountSettings: action.accountSettings,
      };
    default:
      return state;
  }
}
